import { render } from "./cp_score_type1.vue?vue&type=template&id=aa027a4a&scoped=true"
import script from "./cp_score_type1.vue?vue&type=script&lang=js"
export * from "./cp_score_type1.vue?vue&type=script&lang=js"

import "./cp_score_type1.vue?vue&type=style&index=0&id=aa027a4a&scoped=scoped&lang=css"

import exportComponent from "H:\\高报云\\HZY\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa027a4a"]])

export default __exports__